import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Button, Typography } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../utils/hooks';
import { getBarriers } from '../../modules/barriers/selectors';
import { ActionType, SendActionData } from '../../modules/barriers/models';
import { getSelectedHeadLocationUuid } from '../../modules/location/selector';
import { sendActionBarrier } from '../../modules/barriers/operations';

const DataGrid = () => {
  const dispatch = useAppDispatch();

  const rows = useAppSelector((s) => getBarriers(s.barriers));
  const locationUuid = useAppSelector((s) => getSelectedHeadLocationUuid(s.location));

  const handleOpenBarrier = async (uuid: string) => {
    const sendActionData = { locationUuid: locationUuid, barrierUuid: uuid, actionType: ActionType.OPEN } as SendActionData;
    await dispatch(sendActionBarrier(sendActionData));
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ width: '100%' }} aria-label="Zarządzanie szlabanami">
        <TableHead>
          <TableRow
            sx={{
              '& th': {
                fontWeight: 800,
              },
            }}
          >
            <TableCell>Miejsce</TableCell>
            <TableCell>Operacje</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows?.map((row) => (
            <TableRow key={row.uuid} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">
                <Typography sx={{ fontSize: '1.14rem', fontWeight: 800 }}>{row.name}</Typography>
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => handleOpenBarrier(row.uuid)}
                  sx={{ backgroundColor: '#00C4AC', '&:hover': { backgroundColor: '#008D78' } }}
                >
                  Otwórz szlaban
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DataGrid;
